import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Badge, Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, Dropdown } from 'reactstrap';
import AuthCornerImage from '../../assets/img/illustrations/authentication-corner.png';
import { breakpoints, routesSlicer } from '../../helpers/utils';
import { topNavbarBreakpoint } from '../../config';
import { useAuthState } from '../../context';
import * as icon from 'react-bootstrap-icons';

const NavbarDropdownTwo = ({ title, items, right, children, handleSetNavbarCollapsed }) => {
  const { otherInfo } = useAuthState();
  const { nutritionAnalysis } = otherInfo;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  const findTitleName = name => {
    return filterMenuItems().find(routes => {
      if (routes.children) {
        return routes?.children.some(item => {
          return item.name === name;
        });
      }
      return routes.name === name;
    }).name;
  };

  const filterMenuItems = () => {
    const nonAnalysisItems = ['myRecipe', 'products', 'masterItems', 'masterMenus', 'schoolMenus', 'productionRecords', 'inventory'];

    const finalItems = [];
    items.map(element => {
      const childrens = (element.children || []).filter(itm => {
        return (nutritionAnalysis ? true : nonAnalysisItems.includes(itm.id));
      });
      if (childrens.length > 0) {
        const ele = { ...element };
        ele.children = [...childrens];
        finalItems.push(ele);
      }
    });
    return finalItems || [];
  }

  const getTitle = (navItem, index) => {
    if (navItem.name === 'Inbox') {
      return findTitleName(navItem.name);
    }
    if (navItem.name === 'Product list') {
      return findTitleName(navItem.name);
    }
    if (navItem.name === 'Login') {
      return filterMenuItems()[index].name;
    }
    if (navItem.name === 'Wizard') {
      return 'Special';
    }
    if (['myRecipe', 'masterMenus', 'productionRecords'].includes(navItem.id)) {
      return findTitleName(navItem.name);
    }
  };

  const navItemGroup =
    title !== 'Home' &&
    routesSlicer({
      routes: filterMenuItems(),
      rows: title === 'Authentication' && 7
    });

  return (
    <Dropdown
      nav
      inNavbar
      isOpen={dropdownOpen}
      toggle={toggleDropdown}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(true);
        }
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      <DropdownToggle nav caret>
        <icon.ListTask /> {title}
      </DropdownToggle>
      <DropdownMenu right={right} className="dropdown-menu-card mt-0">
        {items.length > 0 && (
          <Card className={'shadow-none max-h-dropdown navbar-card-pages'} >
            <CardBody className={'scrollbar px-0 py-2'}>
              <div className="nav flex-column fs-0">
                <Row noGutters className='m-2'>
                  {items.map((groupItem, index) => {
                    return (
                      <Col
                        xs={6}
                        key={index}
                        className={classNames('col-xl-3', {
                          'col-xl-6': title === 'Reports',
                          'col-xxl-3 col-xl-6  mb-xxl-0 mb-3': title === 'Authentication'
                        })}
                      >
                        {(groupItem.children || []).length == 0 ?
                          <DropdownItem tag={Link} to={groupItem.to} key={groupItem.name} onClick={handleSetNavbarCollapsed} style={{ paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>
                            {groupItem.name}
                            {groupItem.badge && (
                              <Badge color={groupItem.badge.color || 'soft-success'} pill className="ml-2">
                                {groupItem.badge.text}
                              </Badge>
                            )}
                          </DropdownItem>
                          :
                          (groupItem.children || []).map((navItem, i) => {
                            let title = undefined;
                            if (i == 0) {
                              title = groupItem.name;
                            }
                            //const title =  getTitle(navItem, index);

                            return (
                              <Fragment key={`${index}-${i}`}>
                                {/*  {title && <div className="nav-link  py-1 font-weight-bold text-primary">{title}</div>} */}
                                {title && <div className="py-1 font-weight-bold text-primary" style={{ paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>{title}</div>}
                                <DropdownItem tag={Link} to={navItem.to} key={i} onClick={handleSetNavbarCollapsed} style={{ paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>
                                  {navItem.name}
                                  {navItem.badge && (
                                    <Badge color={navItem.badge.color || 'soft-success'} pill className="ml-2">
                                      {navItem.badge.text}
                                    </Badge>
                                  )}
                                </DropdownItem>
                              </Fragment>
                            );
                          })}
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </CardBody>
          </Card>
        )}
        {children}
      </DropdownMenu>
    </Dropdown>
  );
};

NavbarDropdownTwo.propTypes = {
  title: PropTypes.string.isRequired,
  handleSetNavbarCollapsed: PropTypes.func,
  children: PropTypes.node,
  items: PropTypes.array,
  right: PropTypes.bool
};

NavbarDropdownTwo.defaultProps = {
  items: [],
  right: false,
  children: null
};

export default NavbarDropdownTwo;
